module.exports = __webpack_public_path__ + "static/media/navExported.1b1db5b1.svg";